<template>
  <div>
    <b-overlay
      :show="isLoading"
      spinner-variant="primary"
      spinner-larger
    >
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          v-for="(deviceList, index) in datas"
          :key="`wtp_${index}`"
          cols="6"
          md="6"
        >
          <b-card title="">
            <b class="pr-1">{{ deviceList.device_list.device_information.site_name }}</b> <span class="dot normal" /> Normal &nbsp;<span class="dot abnormal" /> Abnormal &nbsp;<span class="dot offline" /> Offline
            <b class="sidebar-right">{{ datenow }}</b>
          </b-card>
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              v-for="(val, key) in mappingTopThreeDevices(deviceList.device_list.device_realtime)"
              :key="`top_${key}`"
              cols="12"
              sm="4"
            >
              <b-card
                v-if="val.device_name.toLowerCase() === 'rssi'"
                body-class="rssi-card"
                class="param-card mb-2"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div class="font-weight-bold">
                    {{ getProvider(deviceList.device_list.device_realtime)[0].device_value }}
                  </div>
                  <div class="d-flex flex-column align-items-end">
                    <div :class="`text-${val.color}`" class="font-weight-bold">
                      {{ val.human_value }}
                    </div>
                    <div>{{ val.device_value }} {{ val.device_default_unit }}</div>
                  </div>
                </div>
              </b-card>
              <b-card class="mb-2" body-class="py-1" v-else>
                <div class="d-flex justify-content-between font-weight-bold">
                  <div>Status <span>{{ val.device_name }}</span>:</div>
                  <span :class="`text-${val.color}`">{{ val.human_value }}</span>
                </div>
              </b-card>
            </b-col>
            <b-col
              v-if="filterPHDevices(deviceList.device_list.device_realtime).length > 0"
              sm="4"
              md="4"
            >
              <b-row
                xl="4"
                sm="4"
              >
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-card 
                    title="PH" 
                    :class="filterTotalizerDevice(deviceList.device_list.device_realtime).length > 0 ? 'ph-card' : ''"
                    :body-class="filterTotalizerDevice(deviceList.device_list.device_realtime).length > 0 ? 'd-flex flex-column align-content-center' : ''"
                  >
                    <!-- apex chart -->
                    <vue-apex-charts
                      type="radialBar"
                      :height="filterTotalizerDevice(deviceList.device_list.device_realtime).length > 0 ? '205' : '186'"
                      :options="lineChartSimpleTemperaturePh.chartOptions"
                      :series="[valueToPercent(lineChartSimpleTemperaturePh.series[index].data)]"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col
                  v-for="(val, key) in filterDevices(deviceList.device_list.device_realtime)"
                  :key="`main_${key}`"
                  cols="6"
                  md="6"
                >
                  <DeviceCard
                    :class="filterTotalizerDevice(deviceList.device_list.device_realtime).length > 0 ? 'mb-2' : ''"
                    :isTotalizer="filterTotalizerDevice(deviceList.device_list.device_realtime).length > 0"
                    :device="val"
                    :has-limit="val.device_name.toLowerCase() === 'debit' ? false : true"
                    :limit="limitDevices[val.device_name.toLowerCase()]"
                  />
                </b-col>
                <b-col 
                  v-for="(val, key) in filterTotalizerDevice(deviceList.device_list.device_realtime)"
                  :key="`totalizer_${key}`"
                  cols="12"
                >
                  <b-card body-class="py-1">
                    <div class="d-flex justify-content-between font-weight-bold">
                      <div>{{ val.device_name }}:</div>
                      <span>{{ val.device_value }} {{ val.device_default_unit }}</span>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BRow, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import DeviceCard from './components/DeviceCardInternal.vue'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")

export default {
  components: {
    VueApexCharts,
    BCard,
    BOverlay,
    BRow,
    BCol,
    DeviceCard,
  },
  data() {
    return {
      datas: [],
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      show: false,
      isLoading: false,
      isInitialLoad: true,
      currentTimeInterval: null,
      dashboardInterval: null,
      limitDevices: {
        cod: {
          min: 0,
          max: 100,
        },
        nh3n: {
          min: 0.00001,
          max: 10,
        },
        tss: {
          min: 0,
          max: 150,
        },
        debit: {
          min: 0,
          max: 100,
        },
      },
      lineChartSimpleTemperaturePh: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 245,
            type: 'radialBar',
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: [$goalStrokeColor2],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '57%',
              },
              track: {
                background: $strokeColor,
                strokeWidth: '50%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: $textHeadingColor,
                  fontSize: '2.86rem',
                  fontWeight: '600',
                  formatter(val) {
                    return parseFloat(((val * (10 - 2)) / 100 + 2).toFixed(2))
                  },
                },
              },
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: 'round',
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
    }
  },
  beforeDestroy() {
    if (this.currentTimeInterval) clearInterval(this.currentTimeInterval)
    if (this.dashboardInterval) clearInterval(this.dashboardInterval)
  },
  created() {
    this.currentTimeInterval = setInterval(() => this.updateCurrentTime(), 1000)
    this.dashboardInterval = setInterval(() => this.getData(), 30000)
    this.getData()
  },
  methods: {
    filterPHDevices(item) {
      const params = ['ph']
      return item.filter(v => v.device_name && params.includes(v.device_name.toLowerCase()))
    },
    filterDevices(item) {
      const params = ['cod', 'nh3n', 'tss', 'debit']
      return item.filter(v => v.device_name && params.includes(v.device_name.toLowerCase()))
    },
    filterTotalizerDevice(item) {
      return item.filter(v => v.device_name && v.device_name.toLowerCase() === 'totalizer')
    },
    getProvider(item) {
      return item.filter(v => v.device_name && v.device_name.toLowerCase() === 'provider')
    },
    mappingTopThreeDevices(item) {
      const devices = this.filterTopThreeDevices(item)
      // First, extract values for UPS and PLN
      const pln = devices.find(d => d.device_name.toLowerCase() === 'pln')
      const ups = devices.find(d => d.device_name.toLowerCase() === 'ups')

      const plnValue = pln?.device_value
      const upsValue = ups?.device_value

      const output = devices.map(device => {
        const result = { ...device }
        const { device_name, device_value } = device

        if (device_name === "PLN") {
          result.human_value = device_value === "true" ? "Online" : "Offline"
          result.color = device_value === "true" ? "success" : "danger"
        }

        else if (device_name === "UPS") {
          if (plnValue === "true" && upsValue === "true") {
            result.human_value = "On Charge"
            result.color = "success"
          } else if (plnValue === "false" && upsValue === "false") {
            result.human_value = "Discharging"
            result.color = "warning"
          } else {
            result.human_value = "Nonactive"
            result.color = "danger"
          }
        }

        else if (device_name === "RSSI") {
          const rssi = parseInt(device_value, 10);
          if (rssi >= -70 && rssi <= -50) {
            result.human_value = "Perfect"
            result.color = "success"
          } else if (rssi >= -85) {
            result.human_value = "Good"
            result.color = "blue"
          } else if (rssi >= -100) {
            result.human_value = "Fair"
            result.color = "warning"
          } else if (rssi >= -110) {
            result.human_value = "Bad"
            result.color = "danger"
          } else {
            result.human_value = "No Signal"
            result.color = "grey"
          }
        }

        return result
      })
      return output
    },
    filterTopThreeDevices(item) {
      const params = ['pln', 'ups', 'rssi']
      return item
        .filter(v => v.device_name && params.includes(v.device_name.toLowerCase()))
        .sort((a, b) => params.indexOf(a.device_name.toLowerCase()) - params.indexOf(b.device_name.toLowerCase()))
    },
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    valueToPercent(val) {
      return ((val - 2) * 100 / (10 - 2)).toFixed(2)
    },
    getData() {
      this.isLoading = this.isInitialLoad // Hanya set isLoading menjadi true pada initial load

      const api = process.env.VUE_APP_DEVICE_API
      const headers = {
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }

      axios.get(`${api}/internal/dashboard/sparing-multiple-internal`, { headers })
        .then(response => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            this.datas = response.data.data
            this.lineChartSimpleTemperaturePh.series = this.datas.map(device => ({
              name: device.device_list.device_information.site_name,
              data: device.device_list.device_realtime
                .filter(realtime => realtime.device_name === 'PH')
                .map(phData => phData.device_value),
            }))
          } else {
            console.error('Invalid response format or empty data array.')
          }

          this.isLoading = false // Set isLoading menjadi false setelah data diterima
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
        .catch(error => {
          console.error('Error fetching data:', error)
          this.isLoading = false // Set isLoading menjadi false jika terjadi error
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
    },
  },
}
</script>

<style lang="scss">
.my-custom-class .card-title {
  color: white;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  &.normal {
    background-color: #03ff2d;
  }

  &.abnormal {
    background-color: #FC4C02;
  }

  &.offline {
    background-color: #0E74FF;
  }
}

.rssi-card {
  padding-top: 4px;
  padding-bottom: 4px;
}
.ph-card {
  height: 260px;
}
.param-card {
  .text-blue {
    color: #0E74FF;
  }
  .text-grey {
    color: #545454;
  }
}
</style>
